export default __webpack_public_path__ + "static/media/check-calidate.91828c00.svg";